import { Injectable } from '@angular/core';
import { ModifyMotorsURLIFrameRequestConfig } from './modify-motors.model';
import { ModifyMotorsAdapter } from './modify-motors.adapter';

@Injectable({
  providedIn: 'root',
})
export class ModifyMotorsService {
  constructor(private modifyMotorsAdapter: ModifyMotorsAdapter) {}

  getIframeURL(config: ModifyMotorsURLIFrameRequestConfig) {
    return this.modifyMotorsAdapter.getIframeURL(config);
  }
}
